import React, { useRef, useState } from 'react'
import { Link } from 'react-router-dom'
import Button from '../general/Button'
import Image from '../general/Image'
import { ROUTES } from '../../routes/RouteList'
import Sidebar from './SIdeBar'
import RouteLoader from './RouteLoader'
import { useSelector } from 'react-redux'
import { discoverUs } from '../../constants/base'

const Header = () => {
    const [showSidebar, setShowSideBar] = useState(false);
    const { tech : {technologies}, spec : {specializationList} } = useSelector((state) => state.common);
    const [isDiscoverOpen, setIsDiscoverOpen] = useState(false);

    return (
        <header className="bg-black border-b border-[#292929] text-white --layout-padding  !py-[20px] lg:!py-[15px] sticky top-0 z-50">
            <RouteLoader />
            <div className="max-width">
                <div className="flex justify-between items-center">
                    <div className='lg:flex lg:items-center lg:gap-[30px]'>
                        <div className="">
                            <Link to="/"><Image className='w-[150px] lg:w-[140px]' src="/images/logo.png" alt="logo" /></Link>
                        </div>

                        <div className='relative' onMouseEnter={() => setIsDiscoverOpen(true)} onMouseLeave={() => setIsDiscoverOpen(false)}>
                            <div className='items-center gap-[5px] cursor-pointer hidden lg:flex text-[1rem]'>
                                Discover Us
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="size-4">
                                    <path fillRule="evenodd" d="M12.53 16.28a.75.75 0 0 1-1.06 0l-7.5-7.5a.75.75 0 0 1 1.06-1.06L12 14.69l6.97-6.97a.75.75 0 1 1 1.06 1.06l-7.5 7.5Z" clipRule="evenodd" />
                                </svg>
                            </div>

                            {/* Dropdown Menu */}
                            {isDiscoverOpen && (
                                <div className="absolute top-full left-0 mt-0 w-56 bg-[#1a1a1a] border border-[#292929] rounded-lg shadow-xl z-50">
                                    {/* Arrow pointer */}
                                    <div className="absolute -top-2 left-6 w-4 h-4 bg-[#1a1a1a] border-t border-l border-[#292929] transform rotate-45"></div>
                                    {/* Menu items */}
                                    <div className="relative z-10 py-1">
                                        {discoverUs.map((item, index) => (
                                            <Link key={index} to={item.URL} target={item.isExternal ? '_blank' : '_self'} className="block px-5 py-3 text-[0.95rem] text-white hover:bg-primary-color transition-all duration-300 ease-in-out border-b border-[#292929] last:border-b-0 hover:pl-6">
                                                <span className="relative"> {item.title} </span>
                                            </Link>
                                        ))}
                                    </div>
                                </div>
                            )}
                        </div>

                        <DiscoverUsDropdown 
                            technologies={technologies}
                            specializations={specializationList}
                        />
                    </div>

                    <div className='lg:hidden' onClick={() => setShowSideBar(true)}>
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="size-10 text-white cursor-pointer">
                            <path strokeLinecap="round" strokeLinejoin="round" d="M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25h16.5" />
                        </svg>
                    </div>

                    <div className='hidden lg:flex items-center gap-[10px]'>
                        <Button className="border border-primary-color text-primary-color rounded px-[20px] py-[5px] text-[1rem]" href={ROUTES.FIND_JOBS}> Join as Developer </Button>
                        <Button className="border border-primary-color text-primary-color rounded px-[20px] py-[5px] text-[1rem]" href={ROUTES.START_HIRING}> Hire Instantly </Button>
                        <Button className="bg-primary-color text-black rounded px-[20px] py-[5px] text-[1rem]" href={ROUTES.LOGIN_REGISTER}> Login </Button>
                    </div>
                </div>
            </div>

            <div className='block lg:hidden'>
                <Sidebar isOpen={showSidebar} onClose={() => setShowSideBar(false)} />
            </div>
        </header>

    )
}

export default Header

// ... existing code ...

const DiscoverUsDropdown = ({ technologies, specializations }) => {
    const [open, setOpen] = useState(false);
    const dropdownEntered = useRef(false);

    const handleMouseLeave = (e) => {    
        setTimeout(() => {
            if (!dropdownEntered.current) {
                setOpen(false);
            }
        }, 1500);
    }

    return (
        <div
            className="relative hidden lg:block"
            onMouseEnter={() => setOpen(true)}
            onMouseLeave={handleMouseLeave}
        >
            <div className='items-center gap-[5px] cursor-pointer flex text-[1rem]'>
                Services
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="size-4">
                    <path fillRule="evenodd" d="M12.53 16.28a.75.75 0 0 1-1.06 0l-7.5-7.5a.75.75 0 0 1 1.06-1.06L12 14.69l6.97-6.97a.75.75 0 1 1 1.06 1.06l-7.5 7.5Z" clipRule="evenodd" />
                </svg>
            </div>
            {open && (
                <div
                    onMouseEnter={() => {
                        dropdownEntered.current = true;
                    }}
                    onMouseLeave={() => {
                        dropdownEntered.current = false;
                        setOpen(false);
                    }}
                    id='services-dropdown'
                    className="fixed left-1/2 top-[60px] z-50 w-[80vw] max-w-5xl -translate-x-1/2
                                bg-[#1a1a1a] border border-[#292929] rounded-lg shadow-xl
                                max-h-[70vh] overflow-y-auto
                                px-0 py-0 flex transition-all"
                >
                    {/* Left Section */}
                    <div className="w-[30%] min-w-[220px] bg-[#181818] border-r border-[#292929] flex flex-col justify-center p-8">
                        <h3 className="font-bold text-2xl text-white mb-2">Any Stack. Any Scale.</h3>
                        <p className="text-gray-300 mb-4 text-[1rem]">From startups to enterprises – build your team with 100+ technologies covered.</p>
                        <div className="font-semibold text-white mb-1">Hire Developers Fast</div>
                        <div className="text-gray-400 text-sm">Get top-tier engineers, pre-vetted and ready to start in 48 hours.</div>
                    </div>

                    {/* Right Section */}
                    <div className="flex-1 flex flex-col md:flex-row gap-0 md:gap-8 p-8">
                        {/* Technologies */}
                        <div className="flex-1 mb-8 md:mb-0">
                            <h4 className="font-semibold text-lg mb-4 text-white">Hire Developers By Technologies</h4>
                            <div className="grid grid-cols-2 md:grid-cols-2 gap-y-1 gap-x-8">
                                {technologies.map((tech) => (
                                    <Link
                                        key={tech.id}
                                        to={`/hire/skill/${tech.slug}`}
                                        className="block py-2 px-2 rounded hover:bg-primary-color hover:text-black transition-all duration-300 border-b border-[#292929] last:border-b-0 text-[0.8rem]"
                                    >
                                        {tech.name}
                                    </Link>
                                ))}
                            </div>
                        </div>
                        {/* Roles */}
                        <div className="flex-1">
                            <h4 className="font-semibold text-lg mb-4 text-white">Hire Developers By Role</h4>
                            <div className="grid grid-cols-1 md:grid-cols-1 gap-y-1 gap-x-8">
                                {specializations.map((role) => (
                                    <Link
                                        key={role.id}
                                        to={`/hire/role/${role.slug}`}
                                        className="block py-2 px-2 rounded hover:bg-primary-color hover:text-black transition-all duration-300 border-b border-[#292929] last:border-b-0 text-[0.8rem]"
                                    >
                                        {role.name}
                                    </Link>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

// ... existing code ...